import { Message } from 'element-ui'

import router from '@/router'
import { pages } from '@/config'
import injectInfo from '@/utils/injectInfo'
import {
  appSessionLogin,
  appTokenLogin,
  pageLogin,
  pageLogout,
  getDictionaryByType,
  getWxLogin,
  changePassword,
} from '@/services'

const state = {
  id: '',
  post: '',
  mobile: '',
  realname: '',
  username: '',
  rolename: '',
  roles: [],
  loaded: false,
  timestamp: `${Date.now()}`,
  dictionary: {},
  sessionId: null,
  deviceGroup: [],

  currentTab: null, // 默认全部 null
}

const getters = {
  getDicByType: state => type => {
    const dic = state.dictionary[type]

    return Array.isArray(dic) ? dic : []
  },

  currentTab: state => state.currentTab,

}

const mutations = {
  setUser (state, user) {
    Object.assign(state, user)
  },
  setLoaded (state, loaded = false) {
    state.loaded = loaded
  },
  setTimestamp (state, timestamp) {
    state.timestamp = timestamp
  },
  clearInfo (state) {
    const user = {
      id: '',
      post: '',
      mobile: '',
      realname: '',
      username: '',
      roles: [],
      deviceGroup: [],
    }
    state.currentTab = null

    const loaded = false

    const timestamp = `${Date.now()}`
    Object.assign(state, {
      user,
      loaded,
      timestamp,
    })
  },
  setDictionary (state, payload) {
    state.dictionary = {
      ...state.dictionary,
      ...payload,
    }
  },
  setCurrentTab (state, tab) {
    state.currentTab = tab
  },
}

const actions = {
  // 系统登陆方式。token 登录 | session 登录
  async appLogin ({ dispatch }) {
    let res = { code: 'success' }

    // try catch 仅仅只为了捕获 JSON.parse 错误
    try {
      /**
       * 无法识别是跨系统统一登录，还是单系统刷新页面
       * 所以认定为多系统统一登录认证的情况，使用token
       */
      const name = window.name
      // 避免token泄露执行清空操作
      window.name = ''

      const token = JSON.parse(name).token

      // token登录 方式成功就成功，不成功就使用 刷新登录 方式
      res = await dispatch('appTokenLogin', token)

      if (res.code !== 'success') {
        res = await dispatch('appSessionLogin')
      }
    } catch (e) {
      res = await dispatch('appSessionLogin')
    }

    return res
  },
  // token登录
  async appTokenLogin ({ dispatch }, token) {
    return dispatch('_login', {
      fn: appTokenLogin,
      params: { token },
    })
  },
  // session登录
  async appSessionLogin ({ dispatch }) {
    return dispatch('_login', {
      fn: appSessionLogin,
    })
  },
  // 用于页面登录
  async pageLogin ({ dispatch }, palyload) {
    const { code, msg } = await dispatch('_login', {
      fn: pageLogin,
      params: palyload,
    })

    if (code === 'success') {
      // 缓存登录成功的用户名
      var storage = window.localStorage
      storage.setItem('username', palyload.username)

      Message({
        type: 'success',
        duration: 1200,
        message: '登录成功正在为你跳转',
        customClass: 'message-show-index',
      })

      // 不知道为什么就是想让你看一下我的登录效果600
      await (time => new Promise((resolve, reject) => void setTimeout(resolve, time)))(800)

      router.push({ path: pages.home.path })
    } else {
      Message({
        type: 'error',
        duration: 1600,
        message: msg || '登录失败，请重新登录',
        customClass: 'message-show-index',
      })

      // 不知道为什么就是想让你看一下我的登录效果600
      await (time => new Promise((resolve, reject) => void setTimeout(resolve, time)))(800)
    }

    return { code, msg }
  },
  async _login ({ commit }, { fn, params }) {
    const res = await fn(params)

    if (res.code === 'success') {
      const info = injectInfo(res)

      if (typeof info !== 'boolean') {
        commit('setUser', info.user)
        commit('setLoaded', info.loaded)
        commit('setTimestamp', info.timestamp)
      }

      return info ? { code: 'success' } : { code: 'error', msg: '用户信息注入失败' }
    } else {
      return {
        code: res.code || 'error',
        msg: res.msg || '登录失败了',
      }
    }
  },
  // 清除信息
  async clearInfo ({ commit }) {
    const user = {
      id: '',
      post: '',
      mobile: '',
      realname: '',
      username: '',
      roles: [],
      deviceGroup: [],
    }

    const loaded = false

    const timestamp = `${Date.now()}`

    commit('setUser', user)
    commit('setLoaded', loaded)
    commit('setTimestamp', timestamp)

    return true
  },
  // 用于用户注销
  async pageLogout ({ commit }) {
    const { code, msg } = await pageLogout()

    if (code === 'success') {
      commit('clearInfo')

      Message({
        type: 'success',
        duration: 1200,
        message: '注销成功正在为你跳转',
      })

      router.push({ path: pages.login.path })
    } else {
      Message({
        type: 'error',
        duration: 1600,
        message: msg || '注销失败，请重新注销',
      })
    }

    return { code, msg }
  },
  // 服务于密码修改
  async changePassword (stroe, params) {
    return changePassword(params)
  },
  /**
   * 对应字典数据修改
   */
  async sendGetDictionaryReq ({ commit, state }, { type }) {
    // 调用获取字典接口
    const res = await getDictionaryByType({ type })

    const { code } = res

    // 成功则修改字典
    if (code === 'success') {
      const data = res.data.list.map(({ name, id, realname, code, roadSegments, ...rest }) => ({
        code,
        name,
        id,
        realname,
        value: id || code,
        text: name || realname,
        roadSegments: !roadSegments
          ? ''
          : roadSegments.map(({ id, code, sname, ...rest }) => ({
            text: sname,
            value: id || code,
            ...rest,
          })),
        ...rest,
      }))

      commit('setDictionary', { [type]: data })
      return state.dictionary[type]
    }
  },

  // 获取字典数据
  async getDictionaryByType ({ commit, dispatch, state }, { type, isUpload }) {
    const {
      dictionary: { [type]: dic = [] },
    } = state

    // 如果已经获取且不需要强制请求，则从数据中取
    if (Array.isArray(dic) && dic.length && !isUpload) {
      return dic
    }

    // Promise 处理同时加载相同的字典
    if (dic && dic.then) {
      const data = await dic

      return data
    }

    const fetchPro = dispatch('sendGetDictionaryReq', { type })

    commit('setDictionary', { [type]: fetchPro })
    // 否则发送请求从后端获取
    const data = await fetchPro

    return data
  },
  // 获取角色字典
  async getRolesType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'roles', isUpload })
  },
  // 获取用户字典
  async getUserType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'user', isUpload })
  },
  /**
   * 获取路线字典(包含对应路段信息)
   */
  async getItineraryType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'roadSection', isUpload })
  },
  /**
   * @description                获取单位字典
   * @param  {boolean} isUpload  是否强制刷新
   * @return                     res
   */
  async getDeptType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'Dept', isUpload })
  },
  /**
   * @description                获取流程状态字典
   * @param  {boolean} isUpload  是否强制刷新
   * @return                     res
   */
  async getStatusType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'status', isUpload })
  },
  /**
   * @description                获取病害小类字典
   * @param  {boolean} isUpload  是否强制刷新
   * @return                     res
   */
  async getSmallDiseaseType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'smallDisease', isUpload })
  },
  /**
   * @description                获取病害大类字典
   * @param  {boolean} isUpload  是否强制刷新
   * @return                     res
   */
  async getBigDiseaseType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'bigDisease', isUpload })
  },
  /**
   * @description                获取损害原因字典
   * @param  {boolean} isUpload  是否强制刷新
   * @return                     res
   */
  async getSpoilType ({ dispatch }, isUpload) {
    return dispatch('getDictionaryByType', { type: 'spoil', isUpload })
  },
  // 获取微信扫码登录图片
  async getWxLogin () {
    return getWxLogin()
  },
}

export const root = {
  state,
  getters,
  actions,
  mutations,
}
